/**
 * Transform a DataRequest object into a FavoriteDataRequest
 */
export default function requestObjectTransformer(request) {
    const favoriteDataRequest = {
        chart_id: request.chartId,
        chart_type: request.queryType,
        metric: request.metrics,
    };
    if (request.aggregationType) {
        favoriteDataRequest.stat = request.aggregationType;
    }
    if ("summaryMetric" in request && request.summaryMetric) {
        favoriteDataRequest.summary_metric = request.summaryMetric;
    }
    if ("correlationAggregationType" in request && request.correlationAggregationType) {
        favoriteDataRequest.correlation_stat = request.correlationAggregationType;
    }
    if ("correlationMetrics" in request && request.correlationMetrics) {
        favoriteDataRequest.correlation_metrics = request.correlationMetrics;
    }
    if (request.filters) {
        const filters = request.filters;
        if (filters.browsers) {
            favoriteDataRequest.test_profile_name = filters.browsers;
        }
        if (filters.browserTypes) {
            favoriteDataRequest.browser_types = filters.browserTypes;
        }
        if (filters.browserVersions) {
            favoriteDataRequest.browser_versions = filters.browserVersions;
        }
        if (filters.connectionTypes) {
            favoriteDataRequest.con = filters.connectionTypes;
        }
        if (filters.customerData) {
            favoriteDataRequest.customer_data = filters.customerData;
        }
        if (filters.dateRange) {
            if ("secondsAgo" in filters.dateRange) {
                favoriteDataRequest.start_time_seconds_ago = filters.dateRange.secondsAgo;
            }
            else {
                favoriteDataRequest.start_time = filters.dateRange.startDate;
                favoriteDataRequest.end_time = filters.dateRange.endDate;
            }
        }
        if (filters.deliveryTypes) {
            favoriteDataRequest.delivery_types = filters.deliveryTypes;
        }
        if (filters.deviceTypes) {
            favoriteDataRequest.device_types = filters.deviceTypes;
        }
        if (filters.errorMessage) {
            favoriteDataRequest.msg = filters.errorMessage[0];
        }
        if (filters.hostnames) {
            favoriteDataRequest.hostname = filters.hostnames;
        }
        if (filters.pathnames) {
            favoriteDataRequest.pathname = filters.pathnames;
        }
        if (filters.metricBounds) {
            favoriteDataRequest.metric_bounds = filters.metricBounds;
        }
        if (filters.inpPhases) {
            favoriteDataRequest.inp_phases = filters.inpPhases;
        }
        if (filters.navigationTypes) {
            favoriteDataRequest.navigation_types = filters.navigationTypes;
        }
        if (filters.operatingSystems) {
            favoriteDataRequest.operating_systems = filters.operatingSystems;
        }
        if (filters.pageAttributes) {
            favoriteDataRequest.page_attributes = filters.pageAttributes;
        }
        if (filters.pageLabels) {
            favoriteDataRequest.label = filters.pageLabels;
        }
        if (filters.regions) {
            favoriteDataRequest.region = filters.regions;
        }
        if (filters.countrySubdivisions) {
            favoriteDataRequest.country_subdivision = filters.countrySubdivisions;
        }
        if (filters.sessionEvents) {
            favoriteDataRequest.session_events = filters.sessionEvents;
        }
        if (filters.siteIds) {
            favoriteDataRequest.site_ids = filters.siteIds;
        }
        if (filters.snapshotIds) {
            favoriteDataRequest.snapshot_ids = filters.snapshotIds;
        }
    }
    if (request.compareFilters) {
        const compareFilters = request.compareFilters;
        if (compareFilters.dateRange) {
            if ("secondsAgo" in compareFilters.dateRange) {
                favoriteDataRequest.compare_start_time_seconds_ago = compareFilters.dateRange.secondsAgo;
            }
            else {
                favoriteDataRequest.compare_start_time = compareFilters.dateRange.startDate;
                favoriteDataRequest.compare_end_time = compareFilters.dateRange.endDate;
            }
        }
    }
    if ("options" in request && request.options) {
        const options = request.options;
        if ("comparePreviousDate" in options) {
            favoriteDataRequest.compare = options.comparePreviousDate;
        }
        if ("convertCountryCodes" in options) {
            favoriteDataRequest.convert_country_codes = options.convertCountryCodes;
        }
        if ("listFilter" in options) {
            favoriteDataRequest.listfilter = options.listFilter;
        }
        if ("maxListItems" in options) {
            favoriteDataRequest.max_items = options.maxListItems;
        }
    }
    return favoriteDataRequest;
}
